import { Fragment, type ReactNode } from 'react';

import { Checkbox } from '@flipster/react/design-system/checkbox';
import { IsomorphicLink, IsomorphicLinkProps } from '@flipster/react/design-utils/isomorphic-link';
import { NoSSR } from '@flipster/react/misc/lifecycle/NoSSR';
import { css } from '@flipster/styled-system/css';

import { zendesk } from '../../../shared/zendesk/url';

export interface TermsLink {
  label: ReactNode;
  link: string;
  external?: boolean;
  noSSR?: boolean;
}

interface Props {
  agreed: boolean;
  onChange: (agreed: boolean) => void;
  terms: TermsLink[];
}

export const AgreeCheckbox = ({ agreed, onChange, terms }: Props) => {
  return (
    <Checkbox checked={agreed} onChange={(e) => onChange(e.target.checked)}>
      I agree to{' '}
      {terms.map((term, index) => {
        const isLast = index === terms.length - 1;
        const isSecondToLast = index === terms.length - 2;

        const link = (
          <UnderlineText href={term.link} external={term.external}>
            {term.label}
          </UnderlineText>
        );

        const wrappedLink = term.noSSR ? <NoSSR>{link}</NoSSR> : link;

        return (
          <Fragment key={index}>
            {wrappedLink}
            {isLast ? '.' : isSecondToLast ? ', and ' : ', '}
          </Fragment>
        );
      })}
    </Checkbox>
  );
};

export const narsilTerms: TermsLink[] = [
  { label: "Flipster's Terms of Use", link: '/policies/terms' },
  { label: 'Dynamic Earn Terms', link: '/policies/dynamic-earn-terms' },
  { label: 'Collaboration terms', link: zendesk.getUrl('DeFiEarnTerms'), external: true, noSSR: true },
  { label: "NARFLUX's Terms of Service", link: 'https://www.narfluxco.com/terms', external: true },
];

const UnderlineText = (props: IsomorphicLinkProps) => {
  return (
    <IsomorphicLink
      className={css({ textStyle: 'Body/XL/Monospace/Underline', color: 'content.default.level-5' })}
      newTab
      {...props}
    >
      {props.children}
    </IsomorphicLink>
  );
};
